import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestAdminReset } from '../../api/auth.api';
import AuthLayout from '../../layouts/AuthLayout';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await requestAdminReset({ email });
      setMessage(res.data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Request failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="mb-7">
        <h2 className="text-2xl font-bold text-slate-900 leading-tight">Reset Password</h2>
        <p className="text-slate-500 text-sm mt-1">Enter your admin email to receive a reset OTP.</p>
      </div>

      {message ? (
        <>
          <Alert type="success" className="mb-5">{message}</Alert>
          <Button fullWidth onClick={() => navigate('/admin/reset-password')}>
            Enter OTP
          </Button>
        </>
      ) : (
        <>
          {error && <Alert type="error" className="mb-5">{error}</Alert>}
          <form onSubmit={handleSubmit} className="space-y-1">
            <Input
              label="Email address"
              type="email"
              placeholder="admin@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className="pt-2">
              <Button type="submit" fullWidth size="lg" loading={loading}>
                Send Reset OTP
              </Button>
            </div>
          </form>
        </>
      )}

      <p className="text-center text-sm text-slate-400 mt-6">
        <a href="/admin/login" className="text-primary-600 hover:text-primary-700 font-medium hover:underline">
          Back to Login
        </a>
      </p>
    </AuthLayout>
  );
};

export default ForgotPassword;
